require("../vendor/slick");
(function ($) {
  $(function () {
    $(".bs-section--why-join-become-member.bs-section--add-progress-bar .bs-tab-slider .bs-slider-content").each((index, element) => {
      const $this = $(element);
      let $slider, $sliderParent;
      if ($this.find(".bs-tab-slider").length) {
        $slider = $this.find(".bs-slider-content");
        $sliderParent = $slider.parent(".bs-tab-slider");
      }
      if ($this.find(".bs-slider").length) {
        $slider = $this.find(".slick-slider");
        $sliderParent = $slider.parent(".bs-slider");
      }
      if (!$sliderParent.find(".progress-bar-container").length) {
        $sliderParent.after('<div class="progress-bar-container"><div class="progress-bar-wrapper"><span class="progress-inner"></span></div><span class="progress-bar-slide-count"></span></div>');
      }
      $sliderParent.each((index, ele) => {
        let uniqSliderId = $(ele).attr("id");
        let slickInitState = $("#" + uniqSliderId).find(".slick-initialized");
        if (slickInitState.length != 0) {
          $(slickInitState).slick("unslick");
          $("#" + uniqSliderId).on("init reInit afterChange", (event, slick) => {
            let currentSlideNumber = (slick.currentSlide ? slick.currentSlide : 0) + 1,
              totalSlideCount = slick.slideCount ? slick.slideCount : 0,
              progressBarValue = (currentSlideNumber / totalSlideCount) * 100 + "%",
              progressBarSlideCount = $("#" + uniqSliderId)
                .parent()
                .find(".progress-bar-slide-count");
            progressBarSlideCount.text(currentSlideNumber + "/" + totalSlideCount);
            $("#" + uniqSliderId)
              .parent()
              .find(".progress-inner")
              .css({
                width: progressBarValue,
              });
          });
          $(slickInitState).slick();
        }
      });
    });
    const sliderArrowParent = $(".bs-section--why-join-become-member");
    const sliderArrows = $(".bs-section--why-join-become-member .bs-tab-slider .bs-slider-tabs").children(".slick-arrow");
    if (sliderArrows.length) {
      sliderArrowParent.addClass("has-arrow");
    } else {
      sliderArrowParent.removeClass("has-arrow");
    }
  });
})(jQuery);
